import { Button } from '@nbirl/nbi-common-ui-libs';
import { FormikConfig } from 'formik';

import { useErrorToast } from '../../../../shared/hooks';
import { ApiError } from '../../../../shared/models';
import { useCreateNewFolder } from '../queries';
import { FolderNameForm, FolderNameFormValue } from './folder-name-form';

type NewFolderProps = {
  parentId?: string;
  onClose: () => void;
  onSuccess: () => void;
};

export const NewFolder = ({ parentId, onClose, onSuccess }: NewFolderProps) => {
  const mutation = useCreateNewFolder();
  const { showErrorToast } = useErrorToast();

  const handleSubmit: FormikConfig<FolderNameFormValue>['onSubmit'] = async (
    values,
    formikHelpers
  ) => {
    const { name } = values;

    try {
      await mutation.mutateAsync({ name, parentId });
      onClose();
      onSuccess();
    } catch (error) {
      if (error instanceof ApiError && error.code === '03001') {
        formikHelpers.setFieldError('name', error.message);
      } else {
        showErrorToast('Unable to add new folder. Please try again.');
      }
    }
  };

  return (
    <div className="border-t border-b border-gray-100 py-14">
      <FolderNameForm onSubmit={handleSubmit} inputLabel="Folder name">
        <div className="flex justify-end space-x-2 mt-4">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" isPending={mutation.isLoading}>
            Create
          </Button>
        </div>
      </FolderNameForm>
    </div>
  );
};
